//@ts-ignore
import React from 'react';
import { MenuNavProps, TMenuType } from './types';

export default function LeftMenuNav(props: MenuNavProps) {
  const { menus, openMenu, loadModel } = props;
  const openedMenu = menus.find((m: TMenuType) => m.open);
  const subMenus = openedMenu ? openedMenu.subMenus : null;
  const openedSubMenus = subMenus ? subMenus.find((sm: TMenuType) => sm.open) : null;
  const subSubMenus = openedSubMenus ? openedSubMenus.subSubMenus : null;
  const handleOpenMenuItem = (
    menuItem: TMenuType,
    menuIndex: number | null,
    subMenuIndex: number | null,
  ) => {
    let i;
    let j: any = null;
    if (menuIndex === null) {
      i = menus.findIndex((m: TMenuType) => m.id === menuItem.menuId);
    } else {
      i = menuIndex;
    }
    if (subMenuIndex !== null) {
      j = subMenuIndex;
    }

    openMenu(i, j);
  };

  return (
    <div id="left-menu" className="container">
      {subSubMenus && subSubMenus.length > 0 && (
        <ul className="subSubMenus">
          {subSubMenus.map((subSubMenu: TMenuType, i: number) => (
            <li key={i} onClick={() => loadModel(subSubMenu)} className="loadModel">
              {subSubMenu.title}
            </li>
          ))}
        </ul>
      )}

      {subMenus && subMenus.length > 0 && (
        <ul className="subMenus">
          {subMenus.map((subMenu: TMenuType, i: number) => (
            <li
              key={i}
              className={`mainLink ${subMenu.open ? 'open' : ''}`}
              onClick={() => {
                if (subMenu.subSubMenus.length > 0) {
                  handleOpenMenuItem(subMenu, null, i);
                } else {
                  loadModel(subMenu);
                }
              }}
            >
              {subMenu.title}
              {subMenu.subSubMenus && subMenu.subSubMenus.length > 0 && (
                <i className="fas fa-caret-down" />
              )}
            </li>
          ))}
        </ul>
      )}

      <ul className="menus">
        {menus.map((menu: any, i: number) => (
          <li
            key={i}
            className={`mainLink ${menus[i].open ? 'open' : ''}`}
            onClick={() => {
              if (menu.subMenus.length > 0) {
                handleOpenMenuItem(menu, i, null);
              } else {
                loadModel(menu);
              }
            }}
          >
            {menu.title}
            {menu.subMenus && menu.subMenus.length > 0 && <i className="fas fa-caret-down" />}
          </li>
        ))}
      </ul>
    </div>
  );
}
